import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((_theme) => ({
    popupElement: {
        width: "100%",
        marginTop: 15,
    }
}));

export default function PlanNo(props) {
    const { t } = useTranslation("translation");
    const classes = useStyles();
    return (
        <TextField
            id="planId"
            onChange={props.FilterPlanId}
            defaultValue={props.planId}
            value={props.planId == 0 ? "" : props.planId}
            label={t("PlanNo")}
            variant="outlined"
            size={props.size ?? "normal"}
            className={classes.popupElement}
            type="number"
            onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12);
            }}
        />
    );
}
